import { isSemanticModelClass, isSemanticModelRelationship, isSemanticModelGeneralization, isSemanticModelAttribute } from "@dataspecer/core-v2/semantic-model/concepts";
import { isSemanticModelClassProfile, isSemanticModelRelationshipProfile } from "@dataspecer/core-v2/semantic-model/profile/concepts";
function filterForExtraction(entities, predicate) {
    const values = entities.filter(({ semanticEntity: semanticModelEntity }) => {
        return predicate(semanticModelEntity);
    });
    return values;
}
/**
 * Converts entities from given semantic model into concrete data types. Returns them in object of type {@link ExtractedModels}
 */
export function extractModelObjects(inputSemanticModels) {
    const entitiesInModels = [...inputSemanticModels.entries()].map(([modelIdentifier, model]) => {
        return Object.entries(model.getEntities()).map(([key, value]) => ({
            sourceModelIdentifier: modelIdentifier,
            semanticEntity: value,
        }));
    });
    const entities = [];
    entitiesInModels.forEach(model => {
        entities.push(...model);
    });
    const classes = filterForExtraction(entities, isSemanticModelClass).map((o) => {
        return {
            sourceModelIdentifier: o.sourceModelIdentifier,
            semanticClass: o.semanticEntity,
        };
    });
    const classesProfiles = filterForExtraction(entities, isSemanticModelClassProfile).map((o) => {
        return {
            sourceModelIdentifier: o.sourceModelIdentifier,
            semanticClassProfile: o.semanticEntity,
        };
    });
    // TODO Hard to solve by myself - Radstr: Profiles - the isSemanticModelAttributeProfile is internal function
    //   of the CME, since it is probably kind of hack, so we can not check it here
    //   So now this contains both relationship profiles and attribute profiles
    //   which matters only if we are using the reactflow dimension estimator.
    //   Currently only the semantic attributes are estimated, the semantic profile attributes not.
    // ... So final remarks idelly we would have relationshipProfiles and attributeProfiles
    const relationshipsProfiles = filterForExtraction(entities, isSemanticModelRelationshipProfile).map((o) => {
        return {
            sourceModelIdentifier: o.sourceModelIdentifier,
            semanticRelationshipProfile: o.semanticEntity,
        };
    });
    const generalizations = filterForExtraction(entities, isSemanticModelGeneralization).map((o) => {
        return {
            sourceModelIdentifier: o.sourceModelIdentifier,
            semanticGeneralization: o.semanticEntity,
        };
    });
    const attributes = filterForExtraction(entities, isSemanticModelAttribute).map((o) => {
        return {
            sourceModelIdentifier: o.sourceModelIdentifier,
            semanticRelationship: o.semanticEntity,
        };
    });
    const relationships = entities
        .filter((o) => (isSemanticModelRelationship(o.semanticEntity) &&
        !isSemanticModelAttribute(o.semanticEntity)))
        .map((o) => {
        return {
            sourceModelIdentifier: o.sourceModelIdentifier,
            semanticRelationship: o.semanticEntity,
        };
    });
    return {
        entities,
        classes,
        classesProfiles,
        relationships,
        relationshipsProfiles,
        generalizations,
        attributes,
    };
}
/**
 * @returns Returns the identifiers of source and target for {@link relationship} and the index where each end lies.
 */
export function getEdgeSourceAndTargetRelationship(relationship) {
    let source, target;
    let sourceIndex, targetIndex;
    if (relationship.ends[0].iri == null) {
        sourceIndex = 0;
        targetIndex = 1;
    }
    else {
        sourceIndex = 1;
        targetIndex = 0;
    }
    source = relationship.ends[sourceIndex].concept;
    target = relationship.ends[targetIndex].concept;
    return { source, target, sourceIndex, targetIndex };
}
export function getEdgeSourceAndTargetGeneralization(relationship) {
    return { source: relationship.child, target: relationship.parent };
}
//# sourceMappingURL=entity-bundles.js.map